module.exports = __webpack_public_path__ + "img/phone.50c1ee9f.png";